module.exports = __webpack_public_path__ + "static/media/roryCV.7e297652.pdf";